<template>
    <rkm-modal
        extraLarge
        ref="RkmModal"
        title="Observação"
    >
        <rkm-alert show info>
            <strong>Paciente:</strong>

            {{ agendamento.pacienteNome }}

            <strong v-if="agendamento.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                ({{ agendamento.PacienteNomeSocial }})
            </strong> -

            <strong>Idade:</strong>
                    <template v-if="agendamento.pacienteIdade">
                        {{ agendamento.pacienteIdade }}
                    </template>
                    <template v-else>
                        -
                    </template> -
            <strong>Prontuário: </strong>{{ agendamento.pacienteProntuario }} -
            <strong>Exame / Grupo: </strong>{{agendamento.exameGrupoNome}} {{ agendamento.pertenceGrupo ? `(${agendamento.nomesExame})` : ''}}
        </rkm-alert>

        <rkm-row>
            <rkm-col>

                <rkm-form
                    ref="Form"
                    show-legend
                >

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                label="Observação"
                                v-model="agendamento.observacao"
                                :validations="validations.observacao"
                                :maxlength="validations.observacao.max"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer>
            <rkm-button @click="handleCancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{ hasObservacao ? 'Alterar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import sexo from '@/enums/cadastro/cidadao/sexo'
import diasSemana from '@/enums/exame-laboratorial/diasSemana'

export default {
    computed: {
        validations() {
            return {
                observacao: { min: 3, max:140 },
            }
        }
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        }
    },
    data: () => ({
        agendamento: {
            data: null,
            exameId: null,
            exameGrupoNome: '',
            pertenceGrupo: null,
            observacao: null,
            itemId: null,
            nomesExame: '',
            diasSemana:null,
            semanaId: null,
            pacienteIdade: null,
            pacienteNome: '',
            pacienteNomeSocial:  '',
            pacientePreferenciaNomeId: null,
            pacienteProntuario:  '',
        },
        hasObservacao: false,
        enums: {
            preferenciaNome,
            sexo,
            diasSemana
        },
    }),
    methods: {
        open(agendamento, item) {

            var data = moment(agendamento.data, 'DD/MM/YYYY').toDate()
            var dia = data.getDay() + 1;

            this.agendamento.diasSemana = this.getStringDiaSemana(dia)

            this.agendamento.data = agendamento.data.split("-").reverse().join("/")
            this.agendamento.exameGrupoNome = item.exameGrupoNome
            this.agendamento.pertenceGrupo = item.pertenceGrupo
            this.agendamento.observacao = item.observacao
            this.agendamento.itemId = item.id
            this.agendamento.nomesExame = item.nomesExame
            this.agendamento.pacienteIdade = agendamento.pacienteIdade
            this.agendamento.pacienteNome = agendamento.pacienteNome
            this.agendamento.pacienteNomeSocial = agendamento.pacienteNomeSocial
            this.agendamento.pacientePreferenciaNomeId = agendamento.pacientePreferenciaNomeId
            this.agendamento.pacienteProntuario = agendamento.pacienteProntuario
            this.hasObservacao = item.observacao

            this.$refs.RkmModal.show()
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                if (!valid) return

                this.itemsNotSave.some(item => item.exames.some(exame => {
                        if (exame.id === this.agendamento.itemId) {
                            exame.observacao = this.agendamento.observacao
                        }
                    })
                );

                this.resetForm()
                this.$refs.RkmModal.hide()
            })
        },
        getStringDiaSemana(dia) {

            if(dia == this.enums.diasSemana.DOMINGO){

               return 'DOMINGO'
            } else if (dia == this.enums.diasSemana.SEGUNDA_FEIRA){

               return 'SEGUNDA-FEIRA'
            } else if (dia == this.enums.diasSemana.TERCA_FEIRA){

               return 'TERÇA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUARTA_FEIRA){

               return 'QUARTA-FEIRA'
            } else if (dia == this.enums.diasSemana.QUINTA_FEIRA){

               return 'QUINTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SEXTA_FEIRA){

               return 'SEXTA-FEIRA'
            } else if (dia == this.enums.diasSemana.SABADO){

               return 'SÁBADO'
            }
        },
        resetForm() {

            this.agendamento.observacao = null
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [ error, repository ],
    props: {
        data: { type: Object, required: true },
        itemsNotSave: { type: Array },
    },
}
</script>

